import type { CarrierStateInput, CarrierTone } from '@/lib/carrier-status'

import { Badge } from '@/components/ui/badge'
import { carrierShipmentDisplay } from '@/lib/carrier-status'

type BadgeVariant =
    'default' | 'secondary' | 'destructive' | 'success' | 'warning'

const TONE_VARIANTS: Record<CarrierTone, BadgeVariant> = {
    neutral: 'secondary',
    progress: 'default',
    success: 'success',
    warning: 'warning',
    danger: 'destructive',
}

/** Trạng thái vận đơn theo mã của hãng, cùng màu ở mọi màn. */
export function CarrierStatusBadge({
    shipment,
}: {
    shipment: CarrierStateInput
}) {
    const display = carrierShipmentDisplay(shipment)
    return <Badge variant={TONE_VARIANTS[display.tone]}>{display.label}</Badge>
}
